module.exports = __webpack_public_path__ + "media/images/common/menu_bg-e32dd83c2d0149426584577365b4dd48.png";